import { Form, Input, Switch, Row, Col, Select, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';

export default function AdUploadFileEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 选择跳转链接类型数据 */
    const [selectLinkTypeData, setSelectLinkTypeData] = useState<any>();

    /** 跳转链接类型数据 */
    const [linkTypeData, setLinkTypeData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = '';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {

                    if (res.data.linkTypeId) {
                        setSelectLinkTypeData(res.data.linkTypeId);
                    }
                }
            })
        }

        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: 'generalData',
                apiVariable: 'linkType',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setLinkTypeData(res.data);
                }
            });
        }
        fetchData();
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    const getLinkTypeData = (linkTypeId: string) => {
        setSelectLinkTypeData(linkTypeId);
    }

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'adFile',
    };

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '广告图片'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={800}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={8}>
                            <Form.Item
                                label="ID"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={16}>
                            <Form.Item
                                label="腾讯视频ID"
                                name="movieId"
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="选择跳转链接类型"
                                name="linkTypeId"
                            >
                                <Select
                                    showSearch
                                    placeholder="跳转链接类型"
                                    optionFilterProp="children"
                                    onSelect={getLinkTypeData}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(linkTypeData, 'name')}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={selectLinkTypeData === 'externalWx' ? 24 : 0}>
                            <Form.Item
                                label="小程序AppId"
                                name="appId"
                                rules={[{ required: selectLinkTypeData === 'externalWx' ? true : false, message: '请输入小程序appId!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={selectLinkTypeData === 'externalWx' || selectLinkTypeData === 'internalLink' ? 24 : 0}>
                            <Form.Item
                                label="跳转到小程序路径"
                                name="wxAddress"
                                rules={[{ required: selectLinkTypeData === 'externalWx' || selectLinkTypeData === 'internalLink' ? true : false, message: '请输入小程序地址!' }]}>
                                <Input placeholder='例如:pages/index/index' />
                            </Form.Item>
                        </Col>

                        <Col span={selectLinkTypeData === 'branchStoreMenuWarehouseId' ? 24 : 0}>
                            <Form.Item
                                label="门店菜式ID"
                                name="branchStoreMenuWarehouseId"
                                rules={[{ required: selectLinkTypeData === 'branchStoreMenuWarehouseId' ? true : false, message: '请输入门店菜式ID!' }]}>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="文件所在"
                                name="fileDestination">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="文件类型"
                                name="fileType">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="文件大小"
                                name="fileSize">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="图片宽度"
                                name="imageWidth">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="文件高度"
                                name="imageHeight">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="默认显示"
                                name="isDefault"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber min={1} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}